import React, { useRef } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../css/entry.css";
import "../css/reports.css";
import { useNavigate } from "react-router-dom";
import SriyanshCardHeader from "../components/CardHeader";
import POReports from "../POReports";

function POSearchDetails() {
  const handleClose = () => {
    // navigate("../", { replace: true });
    navigate(-1);
  };

  const navigate = useNavigate();

  const printRef = useRef(null);

  const handlePrint = () => {
    if (printRef.current) {
      const printWindow = window.open("", "", "height=600,width=800");

      // Include the styles of your application
      const styles = Array.from(document.styleSheets)
        .map((sheet) => {
          try {
            return Array.from(sheet.cssRules || [])
              .map((rule) => rule.cssText)
              .join("");
          } catch (e) {
            return "";
          }
        })
        .join("");

      printWindow.document.write(`<style>${styles}</style>`);
      printWindow.document.write("<body>");
      // printWindow.document.write("<header class='print-header'>My Custom Header</header>");
      // printWindow.document.write("<footer class='print-footer'>Footer Text</footer>");
      printWindow.document.write("<main class='print-content'>");
      printWindow.document.write(printRef.current.innerHTML);
      printWindow.document.write("</main>");
      printWindow.document.write("</body></html>");
      printWindow.document.close();

      printWindow.focus();

      // Add event to calculate page numbers if supported
      printWindow.onload = () => {
        printWindow.print();
      };
    }
  };

  return (
    <>
      {/* <SriyanshCardHeader Title="Reports" /> */}
      <Card className="Formcard">

      <div className="input-groupHeading">
      Reports

            </div>
        <CardContent>
          <div className="a4-portrait" style={{ padding: 20 }} ref={printRef}>
            <POReports />
          </div>
          <div style={{ width: "210mm", padding: 20, margin: "auto" }}>
            <div
              className="flex container"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handlePrint}
                title="Click for Data Save"
              >
                Print Data
              </button>

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close
              </button>
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  );
}

export default POSearchDetails;
